<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Col, Row, Text, Label } from '@Shelly/shelly-design-system';
	import BenefitsContent from './BenefitsContent.svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getPremiumBenefitsList } from 'src/helpers/subscription_benefits_helpers';

	const benefitsList = getPremiumBenefitsList($format);
</script>

{#each benefitsList as benefit}
	<Row>
		<Col sm="6" md="8">
			<div class="d-flex flex-direction-column">
				<div class="d-flex align-items-center flex-wrap mb-xs gap-xs">
					<Text class="text-bold" element="span" styleType="body-small">
						{capFirstChar(benefit.text)}
					</Text>
					<div class="d-flex align-items-center gap-xs">
						{#if benefit.betaFlag}
							<Label type="secondary" value="BETA" size="s" />
						{:else if benefit.comingSoon}
							<Label
								type="secondary"
								value={$format('label_premium_coming_soon', {
									default: 'Coming Soon',
								})}
								size="s"
							/>
						{/if}
						{#if benefit.isAI}
							<Label
								size="xs"
								type="ai"
								value={$format('label_ai', { default: 'ai' }).toUpperCase()}
								icon="fak fa-solid-sparkles"
								iconColor="#0a0a0a"
							/>
						{/if}
						{#if benefit.new}
							<Label
								{...!benefit.isNotPremiumOnly ? { icon: 'fa-solid fa-gem' } : {}}
								type={benefit.isNotPremiumOnly ? 'secondary' : 'premium'}
								size="xs"
								value={$format('label_premium_new', {
									default: 'New',
								}).toUpperCase()}
							/>
						{/if}
					</div>
				</div>

				<Text class="text-color-muted" styleType="body-extra-small">
					{benefit.info}
				</Text>
			</div>
		</Col>
		<Col sm="3" md="2">
			<BenefitsContent benefitSubscription={benefit.basicSubscription} />
		</Col>
		<Col sm="3" md="2">
			<BenefitsContent benefitSubscription={benefit.premiumSubscription} isPremium />
		</Col>
	</Row>
	<hr class="hr-color-2" />
{/each}
